import fetch from '@/utils/fetch'
import constants from '@/utils/constants'

// 教学统计
export function teachingRecordStatic(param:any) {
  return fetch({
    url: constants.API_MODULE_PATH.TEACHING + '/organize/web/teachingRecord/statistics',
    method: 'post',
    data: {
      ...param
    }
  })
}
// 班级列表
export function classroomList(param:any) {
  return fetch({
    url: constants.API_MODULE_PATH.STUDENT + '/organize/classroom/list',
    method: 'post',
    data: {
      ...param
    }
  })
}
// 班级列表（权限）
export function classroomAuthList(param:any) {
  return fetch({
    url: '/api-health/organize/manager/classroom/list',
    method: 'post',
    data: {
      ...param
    }
  })
}
// 教学记录详情
export function teachingRecordInfo(param:any) {
  return fetch({
    url: constants.API_MODULE_PATH.TEACHING + '/organize/web/teachingRecord/info',
    method: 'post',
    data: {
      ...param
    }
  })
}

// 教学记录导出
export function teachingRecordExport(param:any) {
  return fetch({
    url: constants.API_MODULE_PATH.TEACHING + '/organize/web/teachingRecord/statistics/list/export',
    method: 'post',
    data: {
      ...param
    }
  })
}

/**
   * 月评管理
   */
// 月评统计
export function growthStatic(param:any) {
  return fetch({
    url: constants.API_MODULE_PATH.TEACHING + '/organize/web/growth/statistics',
    method: 'post',
    data: {
      ...param
    }
  })
}
// 月评报告详情
export function growthInfo(param:any) {
  return fetch({
    url: constants.API_MODULE_PATH.TEACHING + '/organize/web/growth/info',
    method: 'post',
    data: {
      ...param
    }
  })
}

// 生活记录导出
export function growthRecordExport(param:any) {
  return fetch({
    url: constants.API_MODULE_PATH.TEACHING + '/organize/web/growth/statistics/list/export',
    method: 'post',
    data: {
      ...param
    }
  })
}
